import Rate from './src/main';

/* istanbul ignore next */
Rate.install = function(Vue) {
  Vue.component(Rate.name, Rate);
};

export default Rate;



// WEBPACK FOOTER //
// ./packages/rate/index.js